const initialState = {
  visible: null,
  data: null,
  error: [null, null],
  loading: null,
  payload: null,
};

export default initialState;
